define('pages/home/home_page_view',[
  'backbone',
  'jquery',
  '_',

  'modules/user/user_model',

  'modules/news/news_view',

  'text!./home_page_template.html',
  'text!./home_page_intro_template.html',
  'text!./home_page_news_item_template.html',
], function (
  Backbone,
  $,
  _,
  user,
  NewsView,
  home_page_template,
  home_page_intro_template,
  home_page_news_item_template
) {
  'use strict';
  var View = Backbone.View.extend({
    initialize: function (options) {
      this.subViews = [];
      if (user.get('capabilities').news.in_menu) {
        this.news = new NewsView();
        this.listenTo(this.news.collection, 'sync', function () {
          this.renderNews();
        });
      }

      this.render();
    },

    template: _.template(home_page_template),
    intro_template: _.template(home_page_intro_template),
    news_item_template: _.template(home_page_news_item_template),

    subViews: [],

    render: function () {
      this.$el.html(this.template());
      return this;
    },

    renderIntro: function () {
      this.$('.js-intro').html(this.intro_template());
    },

    renderNews: function () {
      var items = [];

      this.news.collection.each(function (model) {
        var text = model.get('text');
        var links = text.match(/(\[url=.*?url\])/g);
        if (links !== null) {
          links.forEach(function (link) {
            var webaddress = link.match(/(?<=\")(.*?)(?=\")/);
            var displayText = link.match(/(?<=\])(.*?)(?=\[)/);
            var htmlLink = '<a href="' + webaddress[0] + '">' + displayText[0] + '</a>';
            text = text.replace(link, htmlLink);
          });
        }
        model.set('text', text);  
        items.push(this.news_item_template(model.toJSON()));
      }, this);

      this.$('.js-news').html(items);
    },

    remove: function () {
      _.each(this.subViews, function (view) {
        if (view && view.remove) {
          view.remove();
        }
      });
      this.$el.off();
      this.$el.empty();
      this.stopListening();
      return this;
    },
  });
  return View;
});

